import React, { Component, Fragment } from 'react';
import Dialog from '@material-ui/core/Dialog';
import VMButton from '../../../Common/VMButton';
import './GettyVideoCrop.scss'
import i18n from '../../../i18n';
// import '../CropDialog.scss';
import Slider from './VideoSlider'

import '../CropDialog.scss';
import {fabric} from 'fabric';

class GettyVideoCrop extends Component {
    state = {
        crop:{},
        isFixAspect: true,
        
        // VideoSlider의 외부 조작을 통해 Handle Value를 바꾸는 경우 true로 넘겨줘야하며 그외에 경우엔 false
        isManualValueChange: false,

        isReadyVideo: false,
        isPause: false,

        curVideoTime: 0, // (s)
        duration: null, // 영상 길이
     };
 
     videoRef;
     src;
     intervalId;
     orgScale;

     canvas;
     videoImg;

     value = { min:0, max:0 }

     componentWillUnmount = () => {
         this.DisposeCanvas();
     }
     DisposeCanvas =()=>{
        if(this.canvas)
        {
            this.canvas.clear();
            this.canvas = null;
        }
     }

     setInnerRect = (obj) =>
     {
         var heightLimit = this.videoImg.getBoundingRect().height;
         var widthLimit = this.videoImg.getBoundingRect().width;
         var beginX = this.videoImg.getBoundingRect().left;
         var beginY = this.videoImg.getBoundingRect().top;
         
         // if object is too big ignore
        if(obj.currentHeight > heightLimit || obj.currentWidth > widthLimit){
            return;
        }        
        obj.setCoords();        
        // top-left  corner

        if(obj.getBoundingRect().top < beginY || obj.getBoundingRect().left < beginX){
            obj.top = Math.max(obj.top, beginY + obj.top-obj.getBoundingRect().top);
            obj.left = Math.max(obj.left, beginX + obj.left-obj.getBoundingRect().left);
        }
        // bot-right corner
        if(obj.getBoundingRect().top+obj.getBoundingRect().height  > beginY + heightLimit || obj.getBoundingRect().left+obj.getBoundingRect().width  > beginX + widthLimit){
            obj.top = Math.min(obj.top, heightLimit-obj.getBoundingRect().height + beginY + obj.top - obj.getBoundingRect().top);
            obj.left = Math.min(obj.left, widthLimit-obj.getBoundingRect().width + beginX + obj.left - obj.getBoundingRect().left);
        }

     }

     componentDidUpdate = () => {
        //this.DisposeCanvas();
        
        if(!this.canvas && this.state.vWidth)
        {
            this.canvas = new fabric.Canvas('c',{backgroundColor:'rgb(75,75,75)',selection:false});
            var video = document.getElementById('v');
    
            this.videoImg = new fabric.Image(video, {
                width:this.state.vWidth,
                height:this.state.vHeight,
                objectCaching:false,
                originX : 'center',
                originY : 'center',
                selectable : false,
                hoverCursor: 'default'
            });
            var sizeX = this.canvas.width / this.videoImg.width;
            var sizeY = this.canvas.height / this.videoImg.height;
    
            if(sizeX < sizeY)
            {
                sizeY=sizeX;
            }
            else 
            {
                sizeX=sizeY;
            }

            this.videoImg.scaleX = sizeX;
            this.videoImg.scaleY = sizeY;
            


            this.canvas.centerObject(this.videoImg);

            this.canvas.add(this.videoImg);

            var fw,fh;

            if (this.props.aspect >= this.videoImg.width / this.videoImg.height)
            {
                fw = this.videoImg.width;
                fh = fw * 1 / this.props.aspect;
            }
            else
            {
                fh = this.videoImg.height;
                fw = fh * this.props.aspect;
            }
            
            var panel = new fabric.Rect({
                left:0,
                top:0,
                width:this.canvas.width,
                height:this.canvas.height,
                backgroundColor:'rgb(0,0,0)',
                opacity: 0.8,
                selectable:false,
                hoverCursor:'default',
            });
            var center = panel.getCenterPoint();
            this.orgScale = {
                x : this.videoImg.scaleX,
                y : this.videoImg.scaleY
            }
            var mask = new fabric.Rect({
                left:center.x,
                top:center.y,
                width:fw,
                height:fh,
                originX: 'center',
                originY: 'center',
                scaleX : this.orgScale.x,
                scaleY : this.orgScale.y,
                absolutePositioned: true
            });
            mask.inverted = true;
            
            panel.clipPath = mask;
 
            this.maskRect = new fabric.Rect({
                left:center.x,
                top:center.y,
                width:fw,
                height:fh,
                originX: 'center',
                originY: 'center',
                scaleX : this.videoImg.scaleX,
                scaleY : this.videoImg.scaleY,
                fill:'rgba(0,0,0,0)',
                strokeWidth: 6,
                // lockScalingX:true,
                lockRotation: true,
                // lockScalingY:true,
                lockUniScaling: true,
                stroke: 'rgb(139, 197, 65)',
                lockScalingFlip: true,
                hasRotatingPoint: false,
                cornerSize: 20,
                cornerStyle: 'circle',
                cornerColor: 'rgb(139, 197, 65)',
                cornerStrokeColor: 'rgb(139, 197, 65)',
                transparentCorners: false
            });          

            this.maskRect.on('moving', (e)=>{
                var obj = e.target;
                this.setInnerRect(obj);

               mask.left = e.target.left;
               mask.top = e.target.top;
               mask.setCoords();
               panel.clipPath = mask;
               panel.dirty = true;
            });

            this.maskRect.on('scaling', (e)=> {
                var obj = e.target;
                if( obj.scaleX > this.orgScale.x || obj.scaleY > this.orgScale.y)
                {
                    obj.scaleX = this.orgScale.x;
                    obj.scaleY = this.orgScale.y;
                    obj.setCoords();
                }
                this.setInnerRect(obj);
                
               mask.left = e.target.left;
                mask.top = e.target.top;
                mask.scaleX = obj.scaleX;
                mask.scaleY = obj.scaleY;
                mask.setCoords();
                panel.clipPath = mask;
                panel.dirty = true;

            });
            this.canvas.add(panel);
            this.canvas.add(this.maskRect);
            this.canvas.setActiveObject(this.maskRect)

            fabric.util.requestAnimFrame(this.videoRender);
        }
       
     }

     componentDidMount = () =>{
         if(this.props.src) {
            this.setState({src: this.props.src});
         }
     }
    
     videoRender = () => {
         if(this.canvas) {
            this.canvas.renderAll();
            fabric.util.requestAnimFrame(this.videoRender);    
         }
     }
    
     onCropComplete = async ()=>{
        var center = {
            x: this.canvas.width * 0.5,
            y :this.canvas.height * 0.5
        }
        
         var crop = {
            x : (center.x - this.maskRect.left) / (this.maskRect.width * this.maskRect.scaleX),
            y : (center.y - this.maskRect.top) / (this.maskRect.height * this.maskRect.scaleY),
            zoom : this.orgScale.x / this.maskRect.scaleX
        }
        
        this.props.cropComplete({name:this.props.fileName},{from:this.value.min / 1000, to:this.value.max / 1000,crop:crop, source:'gettyimages'});
        this.props.closeDialog();
     }

     checkFrameInRange = ()=>{
        const desDuration = this.value.max / 1000

         try{
            const curVideoTime = this.videoRef.currentTime
            
            // 크롭영역 재생시간이 초과한 경우 
            if(this.videoRef.currentTime >= desDuration)
            {
                // 다시 재생 (처음부터 루프)
                this.playAll()
            }
            this.setState({ curVideoTime })
         }catch(e)
         {
             clearInterval(this.intervalId);
         }
     }

     changeTime = (time) => {
        this.value = time;

        if(this.videoRef) {
            this.setState({ isPause: false })
            this.videoRef.currentTime = time.min / 1000;
            this.videoRef.play();
        } 
     }

     playAll = (isPause = false, restart = true) => {
        const { isReadyVideo } = this.state
        if(isReadyVideo) {
            if(restart) {
                this.videoRef.currentTime = this.value.min / 1000
            }

            if(isPause) {
                this.videoRef.pause()
            }
            else {
                this.videoRef.play()
            }
        }
    }

    handleKeyPress = (e) => {
        if(e.key === "ArrowLeft") {
            this.handleClickLeftFrameBtn()
        }
        else if(e.key === "ArrowRight") {
            this.handleClickRightFrameBtn()
        }
    }

    handleClickPlayAndPauseBtn = () => {
        const isPause = !this.state.isPause
        this.setState({ isPause })
        this.playAll(isPause, false)
    }

    handleClickStopBtn = () => {
        this.setState({ isPause: true })
        this.playAll(true, true)
    }

    handleClickLeftFrameBtn = () => {
        const { cropDuration } = this.props
        this.value = { 
            min: Math.max(0, (this.value.min - 100)), 
            max: Math.max(cropDuration * 1000, (this.value.max - 100)) 
        }
        const curMusicTime = this.value.min / 1000

        this.setState({ curMusicTime, isManualValueChange: true }, () => {
            this.playAll(this.state.isPause, true)
        })
    }

    handleClickRightFrameBtn = () => {
        const { duration } = this.state
        const { cropDuration } = this.props
        this.value = { 
            min: Math.min((duration - cropDuration) * 1000, (this.value.min + 100)), 
            max: Math.min(duration * 1000, (this.value.max + 100)) 
        }
        const curMusicTime = this.value.min / 1000

        this.setState({ curMusicTime, isManualValueChange: true }, () => {
            this.playAll(this.state.isPause, true)
        })
    }

     renderCropper = ()=>{
        const { cropDuration } = this.props
         const { duration, isManualValueChange, curVideoTime } = this.state

         return (
             <Fragment>

                 <canvas id='c' width={600} height={375.5}></canvas>
                 <video
                     ref={ref => { this.videoRef = ref; }}
                     src={this.state.src}
                     id='v'
                     style={{ display: 'none' }}
                     width={this.state.vWidth}
                     height={this.state.vHeight}
                     onCanPlay={(e) => {
                         if (!duration) {
                             this.setState({
                                 isReadyVideo: true,
                                 duration: e.target.duration,
                                 vWidth: e.target.videoWidth,
                                 vHeight: e.target.videoHeight
                             }, () => {
                                this.playAll()
                             });
                         }
                     }}
                     onPlaying={() => {
                         clearInterval(this.intervalId);
                         this.intervalId = setInterval(this.checkFrameInRange, 33);
                     }}
                 />
                 <br></br>
                 <p className="dialog_subtitle">
                     {i18n.t("videocrop-subtitle1")}
                     <img src="https://front.videomonster.com/images-u6yd72dy/web/ic_crop_area.png" alt="" />
                 </p>
                 <p className="GettyVideoCrop-text">{i18n.t("videocrop-text1")}</p>
                 {/* <p className="GettyVideoCrop-text">{i18n.t('videocrop-error')}</p> */}

                 <p className="dialog_subtitle" style={{ marginTop: '15px' }}>
                     {i18n.t("videocrop-subtitle2")}
                     <img src="https://front.videomonster.com/images-u6yd72dy/web/ic_crop_duration.png" alt="" />
                 </p>
                 <p className="GettyVideoCrop-text">{i18n.t("videocrop-text2")}</p>
                 <p style={{ minWidth: '600px', textAlign: "left", fontSize: "12px", color: "#969696" }}><span style={{ color: "#8bc541" }}>**</span>{i18n.t("videocrop-text3")}</p>

                 <div class="video-slider-container">
                     <Slider
                         onChangeTime={this.changeTime}
                         length={cropDuration} // 비디오 총 길이
                         max={duration} // 음악 총 길이
                         indicatorValue={curVideoTime}
                         videoStartTime={this.value.min}
                         isManualValueChange={isManualValueChange}
                     />
                 </div>
             </Fragment>
         );    
                  
     }
     render() {
        const { isPause } = this.state
         const {open} = this.props;

         return (
             <Dialog open={open} maxWidth={"lg"}>
                 <div className="GettyVideoCrop-container">
                    <div
                        ref={ref => ref && ref.focus()}
                        tabIndex="0"
                        onKeyDown={this.handleKeyPress}
                    >
                        <p className="dialog_title">{i18n.t("videocrop-title")}</p>
                        
                        {this.renderCropper()}
                        
                        <div className="dialog-controller-container">
                            <img onClick={this.handleClickLeftFrameBtn} src="https://front.videomonster.com/images-u6yd72dy/web/frameMoveLeft.svg" alt={`icon-frame-move-left`}/>
                            <img onClick={this.handleClickPlayAndPauseBtn} src={isPause ? "https://front.videomonster.com/images-u6yd72dy/web/musicPlayBtn.svg" : "https://front.videomonster.com/images-u6yd72dy/web/musicPauseBtn.svg"} alt={`icon-music-play`}/>
                            <img onClick={this.handleClickStopBtn} src="https://front.videomonster.com/images-u6yd72dy/web/musicStopBtn.svg" alt={`icon-music-stop`}/>
                            <img onClick={this.handleClickRightFrameBtn} src="https://front.videomonster.com/images-u6yd72dy/web/frameMoveRight.svg" alt={`icon-frame-move-right`}/>
                        </div>

                        <div className="VMButton-container">
                            <VMButton onClick={this.onCropComplete} width={'100px'} height={'30px'} color={'primary'} style={{float:'left'}}>{i18n.t("ImageCropDialog.button.complete")}</VMButton>
                            <VMButton onClick={this.props.closeDialog} width={'100px'} height={'30px'}  style={{float:'left'}} >{i18n.t("ImageCropDialog.button.close")}</VMButton>
                        </div>
                    </div>
                 </div>
           
             </Dialog>
         );
     }
}

export default GettyVideoCrop;